import { Form } from 'antd';
import React from 'react';
import styles from './VisibilityDocumentContainer.module.scss';
import Card from '../Card/Card';
import useDocumentVisibilityQuery from '../../queries/useDocumentVisibilityQuery';
import VisibilityDocumentContent from '../VisibilityDocumentContent/VisibilityDocumentContent';
import { ReactComponent as EyeInfo } from '../../../../resource/EyeInfo.svg';
import { useSelector } from 'react-redux';
import { documentDrawerSelector } from '../../store/selectors/new-document.selector';

const VisibilityDocumentContainer = ({ form }) => {
  const { getFieldDecorator } = form;

  const { formValues, mode } = useSelector(documentDrawerSelector);

  const { data } = useDocumentVisibilityQuery();

  const visibleSource = mode === 'edit';

  return (
    <Card
      heading="Видимость документа"
      description="Выберите, для кого будет виден этот документ"
      icon={<EyeInfo />}
    >
      <Form.Item>
        {getFieldDecorator('documentVisibility', {
          rules: [
            {
              required: true,
              message: 'Пожалуйста, укажите видимость документа',
            },
          ],
        })(<VisibilityDocumentContent data={data} />)}
      </Form.Item>
      {visibleSource && (
        <div className={styles.sourceBlock}>
          <div className={styles.name}>Источник:</div>
          <div className={styles.visible}>{formValues?.sourceName}</div>
        </div>
      )}
    </Card>
  );
};

export default VisibilityDocumentContainer;
